'use client'

import { useEffect } from 'react'

type SavedBodyStyles = {
  position: string
  top: string
  width: string
  overflow: string
  paddingRight: string
}

let lockCount = 0
let savedScrollY = 0
let savedBodyStyles: SavedBodyStyles | null = null

function lockBodyScroll() {
  if (lockCount === 0) {
    savedScrollY = window.scrollY
    savedBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
      paddingRight: document.body.style.paddingRight,
    }

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }

    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.width = '100%'
    document.body.style.overflow = 'hidden'
  }

  lockCount += 1
}

function unlockBodyScroll() {
  if (lockCount <= 0) return

  lockCount -= 1

  if (lockCount === 0 && savedBodyStyles) {
    document.body.style.position = savedBodyStyles.position
    document.body.style.top = savedBodyStyles.top
    document.body.style.width = savedBodyStyles.width
    document.body.style.overflow = savedBodyStyles.overflow
    document.body.style.paddingRight = savedBodyStyles.paddingRight
    window.scrollTo(0, savedScrollY)
    savedBodyStyles = null
  }
}

export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return

    lockBodyScroll()

    return () => {
      unlockBodyScroll()
    }
  }, [isLocked])
}
